import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ScrollToTopService {
  scrollToTop(): void {
    setTimeout(() => {
      window.scroll({ top: -1, left: 0, behavior: 'smooth' });
    }, 10);
  }

  scrollToTopInSidebar(): void {
    const sidebarRef = document.getElementById('sidebar-inner');
    if (sidebarRef) {
      setTimeout(() => {
        sidebarRef.scroll({ top: -1, left: 0, behavior: 'smooth' });
      }, 10);
    }
  }
}
